import { call, put, takeLatest } from "redux-saga/effects";
import {
  customerReportFailure,
  customerReportSearchFailure,
  customerReportSearchSuccess,
  customerReportSuccess,
} from "./CustomerReportAction";
import {
  CustomerDateSearchReportEffect,
  customerReportEffect,
} from "./CustomerReportEffect";
import {
  REPORT_CUSTOMER_REPORT_REQUEST,
  REPORT_CUSTOMER_REPORT_SEARCH_REQUEST,
} from "./CustomerReportTypes";

// View All Customer report
function* viewAllCustomerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(customerReportEffect, action.payload, config);

    yield put(customerReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(customerReportFailure({ errormessage: errorMessage }));
  }
}

// View All Search Customer report
function* viewAllSearchCustomerReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      CustomerDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(customerReportSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(customerReportSearchFailure({ errormessage: errorMessage }));
  }
}

export function* CustomerReportSaga() {
  yield takeLatest(REPORT_CUSTOMER_REPORT_REQUEST, viewAllCustomerReportSaga);
  yield takeLatest(
    REPORT_CUSTOMER_REPORT_SEARCH_REQUEST,
    viewAllSearchCustomerReportSaga
  );
}
